export const FieldError = (props) => {
    const { error, touched, className = '' } = props;

    return error && touched ? <div className={`field-error ${className}`}>{error}</div> : null;
};
